import { elementExists } from "../core/utils";

const DestiniModal = function(){
    var myModalEl = document.getElementById('findAStoreModal')
    if( elementExists( myModalEl )){
        myModalEl.addEventListener('show.bs.modal', function (event) {
            const data = event.relatedTarget.dataset;
            destini.init("destini-find-a-store-modal");
            destini.loadWidget('default' , data.destiniApo , data.destiniTitle);
        })
    }
}

export default DestiniModal;